import { Hero } from "@/components/home/Hero";
import { ProductBento } from "@/components/home/ProductBento";
import { Services } from "@/components/home/Services";
import { Experience } from "@/components/home/Experience";
import { NewsTeaser } from "@/components/home/NewsTeaser";
import { CtaBand } from "@/components/home/CtaBand";

export default function Home() {
  return (
    <>
      <Hero />
      <ProductBento />
      <Services />
      <Experience />
      <NewsTeaser />
      <CtaBand />
    </>
  );
}
